import { Component, inject } from '@angular/core';
import { SoilUseService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SoilUseCreateDto,
  SoilUseDto,
  SoilUseExcelDownloadDto,
  SoilUseUpdateDto,
} from '../proxy/planning/dtos/soil-use';
import { SOILUSE_CONFIG, SOILUSE_FIELDS } from './soil-use.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-soil-use',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SoilUseService, ConfirmationService],
  templateUrl: './soil-use.html',
  styleUrl: './soil-use.scss',
})
export class SoilUse extends BaseCrudComponent<
  SoilUseDto,
  SoilUseCreateDto,
  SoilUseUpdateDto,
  SoilUseExcelDownloadDto
> {
  service = inject(SoilUseService);
  config = SOILUSE_CONFIG;
  fields = SOILUSE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SoilUseDto): SoilUseUpdateDto {
    return {
      name: data.name,
      soilUseGroupId: data.soilUseGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SoilUse';
  }
}
